import React from 'react';

import Timeline from './Timeline';

const ResumeSection = ({translate, title, items}) => (
	<div className="row">
		<div className="col s12">
			<h2 className="title text-center">{translate(title)}</h2>
			<Timeline translate={translate} items={items}/>
		</div>
	</div>
);

export default ResumeSection;



// WEBPACK FOOTER //
// ./src/components/elements/Resume/ResumeSection.js